import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import { endpoints } from '@/endpoints';
import { MeResponse } from '@/types/user';
import { mapUserBEToDTO } from '@/mappers/mapUserDTO';
import { ME } from '@/queryKeys';
import { mapOrganizationBEsToDTO } from '@/mappers/mapOrganizationDTO';

export const useGetMe = () => {
  const { sendRequest } = useApi<MeResponse>({
    url: endpoints.me,
    method: 'get',
  });

  return useQuery({
    queryKey: [ME],
    queryFn: async () => {
      const { data } = await sendRequest() as { data: MeResponse };

      return {
        user: mapUserBEToDTO(data.user),
        permissions: data.permissions,
        organization: mapOrganizationBEsToDTO(data.organization),
      };
    },
  });
};
